export default __webpack_public_path__ + "static/media/Glodani 7.642913af.jpg";